import React from 'react';
import { FadeIn } from './FadeIn';
import { CheckCircle2, XCircle } from 'lucide-react';
export function WhoIsItFor() {
  const forWho = ['Padres y madres en zonas de huracanes, incendios o redes eléctricas inestables.', 'Inmigrantes que necesitan proteger su estatus legal y documentos pase lo que pase.', 'Personas que prefieren estar un año adelantados que un segundo tarde.', 'Dueños de casa que quieren asegurar su patrimonio frente a las aseguradoras.'];
  const notForWho = ['Gente que cree que "a mí nunca me va a pasar nada".', 'Personas que buscan manuales de supervivencia extrema en el bosque.', 'Quienes no están dispuestos a dedicar 60 minutos hoy para salvar su futuro mañana.'];
  return <section className="py-24 px-4 bg-brand-dark" data-id="element-216">
      <div className="max-w-6xl mx-auto" data-id="element-217">
        <div className="grid md:grid-cols-2 gap-12" data-id="element-218">
          {/* FOR WHO */}
          <FadeIn data-id="element-219">
            <div className="bg-brand-gray border border-green-500/30 rounded-2xl p-8 h-full" data-id="element-220">
              <h3 className="text-3xl font-display font-bold text-white uppercase mb-8 flex items-center gap-3" data-id="element-221">
                <CheckCircle2 className="text-green-500 w-8 h-8" data-id="element-222" />
                Para quién es esto
              </h3>
              <ul className="space-y-6" data-id="element-223">
                {forWho.map((item, i) => <li key={i} className="flex items-start gap-4" data-id="element-224">
                    <CheckCircle2 className="text-green-500 w-6 h-6 flex-shrink-0 mt-1" data-id="element-225" />
                    <span className="text-gray-300 text-lg" data-id="element-226">{item}</span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>

          {/* NOT FOR WHO */}
          <FadeIn delay={0.2} data-id="element-227">
            <div className="bg-brand-gray border border-red-500/30 rounded-2xl p-8 h-full" data-id="element-228">
              <h3 className="text-3xl font-display font-bold text-white uppercase mb-8 flex items-center gap-3" data-id="element-229">
                <XCircle className="text-red-500 w-8 h-8" data-id="element-230" />
                Para quién NO es
              </h3>
              <ul className="space-y-6" data-id="element-231">
                {notForWho.map((item, i) => <li key={i} className="flex items-start gap-4" data-id="element-232">
                    <XCircle className="text-red-500 w-6 h-6 flex-shrink-0 mt-1" data-id="element-233" />
                    <span className="text-gray-400 text-lg" data-id="element-234">{item}</span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}